import {
	deleteIdbValue,
	persistedDraftIdbStore,
	readIdbValue,
	writeIdbValue,
} from "@/lib/shared/storage/idb";

export type PersistedDraftEnvelope<T> = {
	version: number;
	updatedAt: string;
	value: T;
};

export async function readPersistedDraft<T>(
	key: string,
	options: {
		version: number;
		maxAgeMs?: number;
	},
) {
	const draft = await readIdbValue<PersistedDraftEnvelope<T>>(
		key,
		persistedDraftIdbStore,
	);

	if (!draft) {
		return null;
	}

	if (draft.version !== options.version) {
		await deleteIdbValue(key, persistedDraftIdbStore);
		return null;
	}

	if (
		options.maxAgeMs &&
		Date.now() - new Date(draft.updatedAt).getTime() > options.maxAgeMs
	) {
		await deleteIdbValue(key, persistedDraftIdbStore);
		return null;
	}

	return draft;
}

export async function writePersistedDraft<T>(
	key: string,
	value: T,
	version: number,
) {
	await writeIdbValue<PersistedDraftEnvelope<T>>(
		key,
		{
			version,
			updatedAt: new Date().toISOString(),
			value,
		},
		persistedDraftIdbStore,
	);
}

export async function deletePersistedDraft(key: string) {
	await deleteIdbValue(key, persistedDraftIdbStore);
}
